export const animations = [
  {
    id: "2",
    url: "/lottie/thunderstorm.json",
    image: "/image/thunderstorm.jpg",
  },
  {
    id: "3",
    url: "/lottie/rain.json",
    image: "/image/rain.jpg",
  },
  {
    id: "5",
    url: "/lottie/rain.json",
    image: "/image/rain.jpg",
  },
  {
    id: "6",
    url: "/lottie/snow.json",
    image: "/image/snow.jpg",
  },
  {
    id: "7",
    url: "/lottie/wind.json",
    image: "/image/wind.jpg",
  },
  {
    id: "8",
    url: "/lottie/cloud.json",
    image: "/image/cloud.jpg",
  },
];

export const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];